<template>
  <v-dialog
    width="100%"
    max-width="1400px"
    v-model="dialog"
    scrollable
    @keydown.esc="dialog = false"
  >
    <v-card :loading="loading" v-if="item">
      <v-system-bar window dark
        ><span>Kursrechnung {{ item.number }}</span
        ><v-spacer />
        <v-btn icon @click="dialog = false"
          ><v-icon>mdi-close</v-icon></v-btn
        ></v-system-bar
      >

      <v-card-text class="ma-0 px-4 pt-4">
        <v-row v-if="item">
          <v-col
            cols="12"
            md="5"
            class="full-height d-flex flex-column justify-space-between"
          >
            <FinanceInvoice
              :item="item"
              :showGroup="showGroup"
            ></FinanceInvoice>
          </v-col>
          <v-col cols="12" md="7">
            <FinanceInvoiceDetail :item="item"></FinanceInvoiceDetail>
          </v-col>
        </v-row>
        <v-row v-if="showGroup">
          <v-col cols="12">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Sammelrechnung {{ item.group.number }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <TableComponent
                    :items="groupItem.invoices"
                    :loading="loading"
                    @showDetails="$emit('showDetails', $event)"
                    :group="false"
                  >
                  </TableComponent>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >Beschreibung</v-list-item-subtitle
                        >
                        <v-list-item-title>
                          {{ groupItem.description }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <CurrencyValue :value="total" />
                    </v-list-item>
                  </v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle> iban</v-list-item-subtitle>
                      <v-list-item-title>
                        {{
                          [
                            ...new Set(groupItem.invoices.map((el) => el.iban)),
                          ].join(", ")
                        }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>Status</v-list-item-subtitle>
                      <v-list-item-title>
                        {{
                          [
                            ...new Set(
                              groupItem.invoices.map(
                                (el) => el.status.description
                              )
                            ),
                          ].join(", ")
                        }}</v-list-item-title
                      >
                    </v-list-item-content>

                    <ReportButton
                      resource="report/invoicegroup"
                      :parameters="{ id: groupItem.id }"
                      text
                      outlined
                      dense
                      color="red"
                      >Rechnung</ReportButton
                    >
                  </v-list-item>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <template v-if="item.status.code == 'submitted'">
          <v-btn
            text
            color="primary"
            :to="{
              name: 'FinanceInvoicesSubmittedEdit',
              params: { id: item.id },
            }"
            >bearbeiten</v-btn
          >
          <v-btn
            v-if="!item.group"
            text
            color="error"
            @click="
              doAction({
                action: 'reject',
                message:
                  'Soll die Rechnung an den/die Mitarbeiter/in zurückgewiesen werden?',
                color: 'error',
              })
            "
            >Zurückweisen</v-btn
          >
          <v-btn
            v-if="!item.group"
            text
            color="success"
            @click="
              doAction({
                action: 'submitSap',
                message: 'Soll die Rechnung an SAP übermittelt werden?',
                color: 'success',
              })
            "
            >Übermitteln</v-btn
          >
        </template>
        <template v-if="item.status.code == 'noDetails'">
          <v-btn
            text
            color="info"
            :to="{
              name: 'FinanceInvoicesNoDetailsDistribute',
              params: { id: item.id },
            }"
            >Betrag verteilen</v-btn
          >
          <v-btn
            v-if="!item.group"
            text
            color="success"
            :disabled="item.details.length == 0"
            @click="
              doAction({
                action: 'enter',
                message: 'Soll diese Rechnung verbucht werden?',
                color: 'success',
              })
            "
            >verbuchen</v-btn
          >
        </template>
        <template v-if="item.status.code == 'submittedSap'">
          <v-btn
            text
            color="error"
            v-if="!item.group"
            @click="
              doAction({
                action: 'rejectSap',
                message: 'Soll die Rechnung in SAP zurückgewiesen werden?',
                color: 'error',
              })
            "
            >Zurückweisen</v-btn
          >
          <v-btn
            text
            v-if="!item.group && foreign"
            color="primary"
            @click="
              doAction({
                action: 'foreign',
                message: 'Soll die Rechnung in Fremdwährung verbucht werden?',
                color: 'primary',
              })
            "
            >verbuchen (Fremdwährung)</v-btn
          >
          <v-btn
            text
            v-else-if="!item.group && nodetails"
            color="primary"
            @click="
              doAction({
                action: 'noDetails',
                message: 'Soll die Rechnung ohne Personen verbucht werden?',
                color: 'primary',
              })
            "
            >verbuchen (ohne Personen)</v-btn
          >
          <v-btn
            text
            v-else-if="!item.group"
            color="success"
            @click="
              doAction({
                action: 'enter',
                message: 'Soll die Rechnung verbucht werden?',
                color: 'success',
              })
            "
            >verbuchen</v-btn
          >
        </template>
        <template v-if="item.status.code == 'foreign'">
          <template v-if="item.amount > 0">
            <v-btn
              text
              v-if="nodetails"
              color="primary"
              @click="
                doAction({
                  action: 'noDetails',
                  message: 'Soll die Rechnung ohne Personen verbucht werden?',
                  color: 'primary',
                })
              "
              >verbuchen (ohne Personen)</v-btn
            >
            <v-btn
              v-else
              text
              color="success"
              @click="
                doAction({
                  action: 'enter',
                  message: 'Soll die Rechnung verbucht werden?',
                  color: 'success',
                })
              "
              >verbuchen</v-btn
            >
          </template>

          <v-dialog v-model="exchangeDialog" max-width="500px" v-if="foreign">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" text v-bind="attrs" v-on="on">
                umrechnen
              </v-btn>
            </template>
            <v-card>
              <v-system-bar>Umrechnung Fremdwährung in CHF</v-system-bar>
              <v-list>
                <v-list-item>
                  <v-list-item-subtitle
                    >Betrag auf Rechnung</v-list-item-subtitle
                  >
                  <CurrencyInput
                    readonly
                    :currency="item.currency.code"
                    :value="item.amountForeign"
                  ></CurrencyInput>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-subtitle>Betrag in CHF</v-list-item-subtitle>
                  <CurrencyInput
                    autofocus
                    v-model="exchangeAmount"
                  ></CurrencyInput>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle
                      >Wechselkurs Referenz</v-list-item-subtitle
                    >
                  </v-list-item-content>

                  {{ rateFactor.toLocaleString("de-CH") }}
                  {{ item.currency.code.toUpperCase() }} =
                  {{ rateCheck }}
                  CHF
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle
                      >Wechselkurs Rechnung</v-list-item-subtitle
                    >
                  </v-list-item-content>
                  {{ rateFactor.toLocaleString("de-CH") }}
                  {{ item.currency.code.toUpperCase() }} = {{ rateInvoice }} CHF
                </v-list-item>
              </v-list>
              <v-alert
                class="mb-0"
                text
                tile
                :color="rateDifference < 5 ? 'success' : 'danger'"
              >
                <div class="d-flex align-center justify-space-between">
                  <span>Abweichung Referenz-Rechnung:</span>
                  <v-chip outlined>{{ rateDifference }} %</v-chip>
                </div>
              </v-alert>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn
                  color="primary"
                  text
                  @click="exchange"
                  :loading="loading"
                  :disabled="!exchangable"
                >
                  speichern</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn text @click="exchangeDialog = false" :disabled="loading">
                  abbrechen</v-btn
                >
              </v-card-actions></v-card
            >
          </v-dialog>
        </template>
        <v-spacer />
        <v-btn text @click="dialog = false">schliessen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import CurrencyInput from "common/components/CurrencyInput.vue";
import CurrencyValue from "common/components/CurrencyValue.vue";
import FinanceInvoice from "common/components/Finance/FinanceInvoice.vue";
import FinanceInvoiceDetail from "common/components/Finance/FinanceInvoiceDetail.vue";
import ReportButton from "@/components/ReportButton.vue";
import TableComponent from "./TableComponent.vue";
import { formatDatespan } from "common/utils/date.js";

export default defineComponent({
  components: {
    CurrencyInput,
    CurrencyValue,
    FinanceInvoice,
    FinanceInvoiceDetail,
    ReportButton,
    TableComponent,
  },
  props: ["id"],
  data: () => ({
    dialog: true,
    exchangeDialog: false,
    exchangeAmount: 0,
    item: null,
    groupItem: null,
    loading: false,
    saving: false,
  }),
  computed: {
    rateCheck() {
      return (this.rateFactor / this.item.currency.rate).toFixed(2);
    },
    rateFactor() {
      return Math.pow(
        10,
        Number.parseInt(this.item.currency.rate).toString().length
      );
    },
    rateInvoice() {
      return (
        (this.rateFactor * this.exchangeAmount) /
        this.item.amountForeign
      ).toFixed(2);
    },
    rateDifference() {
      return (
        (100 * Math.abs(this.rateInvoice - this.rateCheck)) /
        this.rateCheck
      ).toFixed(2);
    },
    foreign() {
      return this.item.currency && !this.item.currency.local;
    },
    nodetails() {
      return this.item.details.length === 0;
    },
    exchangable() {
      return (
        this.item.status.code === "foreign" &&
        this.item.amountForeign > 0 &&
        this.exchangeAmount > 0 &&
        this.rateDifference < 5
      );
    },
    showGroup() {
      return this.item && this.groupItem;
    },
    total() {
      if (!this.groupItem || !this.groupItem.invoices) return 0;
      const total = this.groupItem.invoices.reduce(
        (sum, invoice) => sum + invoice.amount,
        0
      );
      return total;
    },
  },

  watch: {
    dialog() {
      if (!this.dialog) {
        const parentRoute = this.$route.matched.slice(-2).shift();
        this.$router.push({
          name: parentRoute.name,
        });
      }
    },
    exchangeDialog() {
      if (this.exchangeDialog) {
        this.exchangeAmount = this.item.amount;
      }
    },
    id() {
      this.fetchData();
    },
  },
  methods: {
    async doAction({ action, ...args }) {
      if (await this.$root.confirm(args)) {
        await this.apiPatch({
          resource: "finance/invoice",
          id: this.id,
          key: "action",
          value: action,
        });
        this.$emit("update");
        this.dialog = false;
      }
    },

    async exchange() {
      if (this.exchangeAmount) {
        this.loading = true;
        await this.apiPatch({
          resource: "finance/invoice",
          id: this.id,
          key: "exchange",
          value: this.exchangeAmount,
        });
        this.exchangeDialog = false;
        this.$emit("update");
        this.fetchData();
      }
    },
    formatDatespan,
    async fetchData() {
      this.loading = true;
      this.item = await this.apiGet({
        resource: "finance/invoice",
        id: this.id,
      });
      if (this.item.group) {
        this.groupItem = await this.apiGet({
          resource: "finance/invoicegroup",
          id: this.item.group.id,
        });
      } else {
        this.groupInvoices = null;
      }
      this.loading = false;
    },
  },

  async created() {
    this.fetchData();
  },
});
</script>
